import { Helmet } from 'react-helmet-async';

import { APP_CONFIG } from '@/constants/app-config';
import { useTwin } from '@/lib/hooks/api/twin.hook';
import { useAuth } from '@/lib/hooks/useAuth';
import useColors from '@/lib/hooks/useColors';
import { RouteTypes } from '@/types/config-types';
import AuthGuard from './AuthGuard';

const AppRoute = ({ ...props }: RouteTypes) => {
  const { component: Component, name, path } = props;
  const { isAuthenticated } = useAuth();
  const { twinData } = useTwin();
  const PersonalityName = twinData?.personalityName;

  const { primaryColor } = useColors();

  const title = isAuthenticated
    ? path.startsWith('/chat/')
      ? `${PersonalityName ?? 'Chat'} | ${APP_CONFIG.appName}`
      : name
        ? `${name} | ${APP_CONFIG.appName}`
        : APP_CONFIG.appName
    : name
      ? `${name} | ${APP_CONFIG.appName}`
      : APP_CONFIG.appName;

  return (
    <>
      <Helmet>
        <title>{title || '3D Printing Support'}</title>
        <meta
          name="description"
          content="Sharing knowledge & wisdom to better the world"
        />
        <meta name="theme-color" content={primaryColor} />
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content={primaryColor}
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="@/assets/favicon.ico"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="@/assets/favicon.ico"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="@/assets/favicon.ico"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link
          rel="mask-icon"
          href="/safari-pinned-tab.svg"
          color={primaryColor}
        />
      </Helmet>
      <AuthGuard routeKey={props.routeKey}>
        <Component />
      </AuthGuard>
    </>
  );
};

export default AppRoute;
